var map = {
	"./editorBaseApi": [
		4858
	],
	"./editorBaseApi.js": [
		4858
	],
	"./editorSimpleWorker": [
		7798
	],
	"./editorSimpleWorker.js": [
		7798
	],
	"./editorWorker": [
		304,
		792
	],
	"./editorWorker.js": [
		304,
		792
	],
	"./editorWorkerHost": [
		6358
	],
	"./editorWorkerHost.js": [
		6358
	],
	"./findSectionHeaders": [
		9307
	],
	"./findSectionHeaders.js": [
		9307
	],
	"./getIconClasses": [
		7762,
		792
	],
	"./getIconClasses.js": [
		7762,
		792
	],
	"./languageFeatureDebounce": [
		4791,
		792
	],
	"./languageFeatureDebounce.js": [
		4791,
		792
	],
	"./languageFeatures": [
		2230,
		792
	],
	"./languageFeatures.js": [
		2230,
		792
	],
	"./languageFeaturesService": [
		501,
		792
	],
	"./languageFeaturesService.js": [
		501,
		792
	],
	"./languageService": [
		6123,
		792
	],
	"./languageService.js": [
		6123,
		792
	],
	"./languagesAssociations": [
		5996,
		792
	],
	"./languagesAssociations.js": [
		5996,
		792
	],
	"./languagesRegistry": [
		6995,
		792
	],
	"./languagesRegistry.js": [
		6995,
		792
	],
	"./markerDecorations": [
		886,
		792
	],
	"./markerDecorations.js": [
		886,
		792
	],
	"./markerDecorationsService": [
		453,
		792
	],
	"./markerDecorationsService.js": [
		453,
		792
	],
	"./model": [
		4830,
		792
	],
	"./model.js": [
		4830,
		792
	],
	"./modelService": [
		125,
		792
	],
	"./modelService.js": [
		125,
		792
	],
	"./resolverService": [
		7042,
		792
	],
	"./resolverService.js": [
		7042,
		792
	],
	"./semanticTokensDto": [
		9376,
		792
	],
	"./semanticTokensDto.js": [
		9376,
		792
	],
	"./semanticTokensProviderStyling": [
		9520,
		792
	],
	"./semanticTokensProviderStyling.js": [
		9520,
		792
	],
	"./semanticTokensStyling": [
		2891,
		792
	],
	"./semanticTokensStyling.js": [
		2891,
		792
	],
	"./semanticTokensStylingService": [
		8148,
		792
	],
	"./semanticTokensStylingService.js": [
		8148,
		792
	],
	"./textModelSync/textModelSync.impl": [
		1305
	],
	"./textModelSync/textModelSync.impl.js": [
		1305
	],
	"./textModelSync/textModelSync.protocol": [
		5628,
		792
	],
	"./textModelSync/textModelSync.protocol.js": [
		5628,
		792
	],
	"./textResourceConfiguration": [
		1504,
		792
	],
	"./textResourceConfiguration.js": [
		1504,
		792
	],
	"./treeSitterParserService": [
		5320,
		792
	],
	"./treeSitterParserService.js": [
		5320,
		792
	],
	"./treeViewsDnd": [
		2603,
		792
	],
	"./treeViewsDnd.js": [
		2603,
		792
	],
	"./treeViewsDndService": [
		6756,
		792
	],
	"./treeViewsDndService.js": [
		6756,
		792
	],
	"./unicodeTextModelHighlighter": [
		9887
	],
	"./unicodeTextModelHighlighter.js": [
		9887
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi": [
		4858
	],
	"monaco-editor/esm/vs/editor/common/services/editorBaseApi.js": [
		4858
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker": [
		7798
	],
	"monaco-editor/esm/vs/editor/common/services/editorSimpleWorker.js": [
		7798
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker": [
		304,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorker.js": [
		304,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost": [
		6358
	],
	"monaco-editor/esm/vs/editor/common/services/editorWorkerHost.js": [
		6358
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders": [
		9307
	],
	"monaco-editor/esm/vs/editor/common/services/findSectionHeaders.js": [
		9307
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses": [
		7762,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/getIconClasses.js": [
		7762,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce": [
		4791,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce.js": [
		4791,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures": [
		2230,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeatures.js": [
		2230,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService": [
		501,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languageFeaturesService.js": [
		501,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languageService": [
		6123,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languageService.js": [
		6123,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations": [
		5996,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languagesAssociations.js": [
		5996,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry": [
		6995,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/languagesRegistry.js": [
		6995,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations": [
		886,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorations.js": [
		886,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService": [
		453,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/markerDecorationsService.js": [
		453,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/model": [
		4830,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/model.js": [
		4830,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/modelService": [
		125,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/modelService.js": [
		125,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService": [
		7042,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/resolverService.js": [
		7042,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto": [
		9376,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensDto.js": [
		9376,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling": [
		9520,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling.js": [
		9520,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling": [
		2891,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStyling.js": [
		2891,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService": [
		8148,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService.js": [
		8148,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl": [
		1305
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.impl.js": [
		1305
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol": [
		5628,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/textModelSync/textModelSync.protocol.js": [
		5628,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration": [
		1504,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/textResourceConfiguration.js": [
		1504,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService": [
		5320,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/treeSitterParserService.js": [
		5320,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd": [
		2603,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDnd.js": [
		2603,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService": [
		6756,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/treeViewsDndService.js": [
		6756,
		792
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter": [
		9887
	],
	"monaco-editor/esm/vs/editor/common/services/unicodeTextModelHighlighter.js": [
		9887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9204;
module.exports = webpackAsyncContext;